import { CURRENCY_CODES, type TCurrencyCode } from '@/infra/types/common';
import { type TOptional } from '@/types/common';

const validateCurrencyCode = (value?: string, allCurrencies?: TCurrencyCode[]): TOptional<TCurrencyCode> => {
  const currencyCode = value?.toUpperCase();
  if (currencyCode && (allCurrencies ?? CURRENCY_CODES).includes(currencyCode)) return currencyCode as TCurrencyCode;
};

export default validateCurrencyCode;
